export enum Gender {
    MALE = 1,
    FEMALE = 2
}
